export interface DeliveryNotePartiesModel {
  address: string;
  id: string;
  name: string;
  type: string;
}
